import React, {useRef} from 'react'
import { fileKey, fileUrl } from '../../../../../util/file_url'
import ImageDisplay from './ImageDisplay'
import ModelDisplay from './ModelDisplay'
import AudioDisplay from './AudioDisplay'
import VideoDisplay from './VideoDisplay'
import PDFDisplay from './PDFDisplay'
import { findExtension, isAudio, isVideo, isModel, isDocument, isImage ,checkNotUndefindeNull} from '../../../../Templates/functions'
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { fullScreenSquare, AttachmentArrowRight, AttachmentArrowLeft, modelSettings,ModelImageCapture } from '../../../../Templates/icons'
import Drawer from "@material-ui/core/Drawer";
import TableOfContents from '../../Preview/TableOfContents/TableOfContents'
import { useClickListener } from '../StepContent/useClickListener'
const TemporaryDrawer = (displayingTOC, toggleTOC, props ) => {
    useClickListener((e) => handleClickOutside(e, toggleTOC))
    const tocRef = useRef(null);
    const wrapperRef = useRef(null)

    const handleClickOutside = (event, cb) => {
        if (wrapperRef && (wrapperRef.current !== event.target)) {
            log()  
        }
        return
    }

    const log = () => {
        if (tocRef.current) {
            return
        }
        
    };
    return (
        <div >
            <React.Fragment key={"right"}>
                <Drawer
                    ref={wrapperRef}
                    anchor={"right"}
                    open={displayingTOC}
                    onClose={toggleTOC}
                >
                <TableOfContents
                    ref={tocRef}
                    currentStep={props.currentStep}
                    steps={props.steps}
                    fromPreview={true}
                    checkForButtonClick={props.checkForButtonClick}
                    updateCurrentStepIndex={props.updateCurrentStepIndex}
                    path={props.path}
                    currentStepIndex={props.currentStepIndex}
                    infoItems={props.infoItems}
                    currentStepInfoItems={props.currentStepInfoItems}
                    viewAttachment={props.viewAttachment}
                    viewingAttachment={props.viewingAttachment}
                />
                </Drawer>
            </React.Fragment>
        </div>
    );
}

const AttachmentRenderer = (props) => {
    const [showWebGLSettings, setWebGLSettings] = React.useState(false);
    const handle = useFullScreenHandle();

    const currentAttachment = props.attachments[props.attachmentIndex]
    const filename = props.viewingAttachment || currentAttachment ? currentAttachment.path : ""
    // The displays fetch the file by its key, "<attachment id>/<name>".
    const key = filename ? fileKey(currentAttachment) : ""
    let ext = findExtension(filename);
    let content
    let typeModel = isModel(ext)
    //alert("MODEL: " + typeModel + "  libraryOpen: " + props.libraryOpen)
    if (isAudio(ext)) {
        content = <AudioDisplay 
                    fromPreview={props.fromPreview} 
                    filename={key} />
    } else if (typeModel && !props.libraryOpen) {
        content = <ModelDisplay
                    key={currentAttachment._id}
                    model={currentAttachment}
                    fromPreview={props.fromPreview}
                    showWebGLSettings={showWebGLSettings}
                    setWebGLSettings={setWebGLSettings}
                    convertModelToImage={props.convertModelToImage}
                    storeCameraData={props.storeCameraData}
                    updateColor={props.updateColor}
                    updateCurrentCameraPlacement={props.updateCurrentCameraPlacement} 
                    toggleAnnotation={props.toggleAnnotation}
                    unityContextRef = {props.unityContextRef}
                    updateUnityContext = {props.updateUnityContext}
                    callFromAuthor = {props.callFromAuthor}
                    addAnnotation={props.addAnnotation}
                    onModelsLoaded={props.onModelsLoaded}
                    isPDFViewer={props.isPDFViewer}
                    />
    } else if (isVideo(ext)) {
        content = <VideoDisplay 
                    filePath={key} 
                    fromPreview={props.fromPreview} />
    } else if (isImage(ext)) {
        content = <ImageDisplay 
                    src={fileUrl(key)} 
                    alt="default-attachment" 
                    fromPreview={props.fromPreview} />
    } else if (isDocument(ext)) {
            content = <PDFDisplay 
                        filename={key} 
                        fromPreview={props.fromPreview} />
    }

    return <div className={`relative ${props.height ? 'max-width' : "max-size"} flex-column-centered`} 
                style={props.height ? { height: props.height, background: "#707070"} : {}}>
            <FullScreen handle={handle}>
                {typeModel && !props.fromPreview && props.textSelectedInEditorFlag? 
                <div style={{width:"90%", marginLeft:"5%", marginRight:"5%",height:"30px", position:"absolute",top:"1em", zIndex:"1",textAlign:"center"}}>
                    <h3 style={{color:"red"}}>Please adjust model to desired position and click to confirm.</h3>
                </div> : null}                                                                       
                {props.attachmentIndex > 0 ? AttachmentArrowLeft(() => props.setAttachmentIndex(props.attachmentIndex - 1)) : null}
                {props.attachmentIndex < props.attachments.length - 1 ? AttachmentArrowRight(() => props.setAttachmentIndex(props.attachmentIndex + 1)) : null}
                {/* {typeModel && !props.fromPreview ? ModelImageCapture(() => props.unityContextRef.send("Manager", "TakeScreenShot")) : null}                                                                       
                {typeModel && !props.fromPreview ? modelSettings(() => setWebGLSettings(showWebGLSettings ? false : true)) : null} */}
                {content}
            </FullScreen>
            {props.fromPreview ? TemporaryDrawer(props.displayingTOC, props.toggleTOC, props): null}
            {props.fromPreview ?fullScreenSquare(handle.enter) : null}
    </div>
}

export default AttachmentRenderer